<template>
  <div>
    <!-- 主要内容 -->
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="showModal">
      新增
    </a-button>
    <a-table 
      :columns="columns" 
      :data-source="data" 
      :loading="loading"
      :pagination="pagination"
      :row-key="(record) => record.id"
      @change="handleTableChange">

      <template slot="store" slot-scope="text, record">
        {{ getStoreNameByShopNo(record.store) }}
        
      </template>
       <template slot="tag" slot-scope="text, record">
        <span v-if="record.tag == 1">美团</span>
        <span v-if="record.tag == 2">抖音</span>
        <span v-if="record.tag == 3">快手</span>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a
          @click="buttonEdit(record)"
          
        >
          {{ data.length>0? '编辑':'' }}
        </a>
        <a
          @click="buttonDelete(record)"
          
        >
          {{ data.length>0? '删除':'' }}
        </a>
      </template>
     
    </a-table>
    
    <!-- 模态框 -->
    <a-modal
      :title="title"
      v-model:visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onSubmit"
      @cancel="resetFields"
      :width="600"
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="门店名称" v-bind="validateInfos.store">
            <a-select  placeholder="请选择门店"  style="width: 300px;" v-model="modelRef.store" :disabled="edit">
              <a-select-option 
                v-for="(item,index) in storeList" 
                :key="index"
                :value="item.shopNo" 
                :id="item.objId">
                {{ item.name }}
              </a-select-option>
            </a-select>
        </a-form-model-item>
        <a-form-item label="平台" v-bind="validateInfos.type">
          <a-radio-group v-model:value="modelRef.type" :disabled="edit">
            <a-radio value="1" name="type">美团</a-radio>
            <a-radio value="2" name="type">抖音</a-radio>
            <a-radio value="3" name="type">快手</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="三方商户号" v-bind="validateInfos.thirdShop"
         :rules="[{ required: true, message: '请填写商户号！' }]"
         >
          <a-input v-model:value="modelRef.thirdShop" placeholder="第三方签约的商户号"/>
        </a-form-item>
        <a-form-item label="门店名称" v-bind="validateInfos.name">
          <a-input v-model:value="modelRef.name" placeholder="门店名称" />
        </a-form-item>
        <!-- <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click.prevent="onSubmit">提交</a-button>
          <a-button style="margin-left: 10px" @click="resetFields">清空</a-button>
        </a-form-item> -->
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getStoreMessage,addStoreMessage,updateStoreMessage ,deleteStoreMessage} from "@/api/admin.js";

import { message } from "ant-design-vue";

const columns = [
  {
    title: "归属门店",
    dataIndex: "store",
    key: "0",
    align: "center",
    width:200,
    scopedSlots: { customRender: "store" },
  },
  {
    title: "平台",
    dataIndex: "tag",
    key: "1",
    align: "center",
    width:200,
    scopedSlots: { customRender: "tag" },
  },

 
  {
    title: "三方商户号",
    dataIndex: "thirdShop",
    align: "center",
    key: "2",
    width:400,
  
  },
  {
    title: "门店名称",
    dataIndex: "thirdShopName",
    align: "center",
    key: "3",
    width:300,
  
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    key: "4",
    align:"center",
  },

];

export default {
  data() {
    return {
      data: [],
      loading: false,
      columns,
      visible: false,
      title: "新增",
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      modelRef: {
        type: "",
        thirdShop: '',
        thirdShopName: '',
        name: '',
        id:null,
        store:"",
        shop:"",
      },
      validateInfos: {
        id: null,
        type: "",
        thirdShop: "",
        name: "",
      },
      confirmLoading: false,
      pagination: {
        pageSize: 10,
        total: 0,
        current: 1,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        onChange: () => {},  // 添加一个空的onChange函数，满足分页组件的期望
      },
      edit: false
    };
  },
  mounted() {

  },
  props: ["formInline","storeList"],
  computed: {

  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },

      getStoreNameByShopNo(shopNo) {
        const ob = this.storeList.find(item => item.shopNo === shopNo);
        // console.log('门店名称:', ob)
        return ob ? ob.name : shopNo;
      },

    // 查询
    search() {
      this.data = [];
      this.loading = true;
      console.log('查询参数:', this.formInline);
      getStoreMessage(this.formInline.store,this.formInline.type,this.pagination.current,this.pagination.pageSize).then((res) => {
        this.loading = false;
        if(res.code == "0" && res.data){
          this.data = res.data;
          this.pagination.total = res.count;
        }else{
          message.error('暂无数据');
        }
        console.log('请求成功，返回数据:', res);
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('error', error);
      });
    },

    getShop(){
      this.data = [];
      this.loading = true;
      getStoreMessage(this.formInline.store,this.formInline.type,this.pagination.current,this.pagination.pageSize).then((res) => {
        this.loading = false;
        if(res.code =="0" && res.data){
          this.data = res.data;
          this.pagination.total = res.count;
        }else{
          message.error('暂无数据');
        }
        console.log('请求成功，返回数据:', res);
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('error', error);
      });

    },

    showModal() {
      this.visible = true;
      this.edit = false;
      this.modelRef = {
        type: "",
        thirdShop: '',
        name: '',
        id:null,
        store:"",
        shop:"",
        storeName:''
      };
    },
    
    handleOk(e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    
    onSubmit() {
      this.loading = true;
      // 提交表单逻辑
      if(this.edit){ 
        // 修改
        console.log('修改:', this.modelRef);
        updateStoreMessage({
          id: this.modelRef.id,
          thirdShop: this.modelRef.thirdShop,
          thirdShopName: this.modelRef.name,
          tag: this.modelRef.type,
          store: this.modelRef.store,
          shop:this.modelRef.shop,
        }).then((res) => {
          this.loading = false;
          if(res.success){
            message.success(res.info);
            this.getShop();
          }else{
            message.error(res.info);
          }
          console.log('请求成功，返回数据:', res);
        }).catch((error) => {
          this.loading = false;
          console.error('请求出错:', error);
        })
      }else{ 
        //新增
        console.log('新增:', this.modelRef);
        addStoreMessage({
          thirdShop: this.modelRef.thirdShop,
          thirdShopName: this.modelRef.name,
          tag: this.modelRef.type,
          store:this.modelRef.store,
        }).then((res) => {
          this.loading = false;
          console.log('请求成功，返回数据:', res);
          if(res.success){
            message.success(res.info);
            this.pagination.current = 1;
            this.pagination.pageSize= 10;
            this.getShop();
          }else{
            message.error(res.info);
          }
        }).catch((error) => {
          this.loading = false;
          console.error('请求出错:', error);
          message.error('error', error);
        })
      }
      this.visible = false;
    
    },
    
    resetFields() {
      console.log('重置表单');
      this.modelRef = {
        type: "",
        thirdShop: '',
        thirdShopName: '',
        name: '',
        id:null,
        store:"",
        shop:"",
      };
    },
    
    handleTableChange(pagination, filters, sorter) {
      console.log('表格变化:', pagination, filters, sorter);
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.search();
    },
    
    buttonEdit(record) {
      this.edit = true;
      console.log('编辑记录:', record);
      this.text = '编辑';
      this.modelRef = {
        id: record.id,
        type: record.tag,
        thirdShop: record.thirdShop,
        name: record.thirdShopName,
        store: record.store,
        shop: record.shop
      };
      this.visible = true;
    },
    buttonDelete(record) {
      console.log('删除记录:', record);
      this.$confirm({
        title: "确定要删除吗?",
        content: "当您点击确定按钮后，该记录将被删除",
        okText: "确定",
        cancelText: "取消",
        onOk:()=> {
          deleteStoreMessage(record.id).then((res) => {
              if(res.success){
                message.success(res.info);
                this.getShop();
              }else{
                message.error(res.info);
              }
              console.log('请求成功，返回数据:', res);
            }).catch((error) => {
              console.error('请求出错:', error);
            })
        },
        onCancel() {
          console.log("点击了取消");
        }
        
        
      })
    },
  },
};
</script>

<style scoped>
.test {
  position: relative;
  left: 55px;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #fafafa;
}
[data-theme='dark'] #components-table-demo-summary tfoot th,
[data-theme='dark'] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
</style>


// WEBPACK FOOTER //
// src/views/thirdShopManagementAdmin/thirdShopContentAdmin.vue